import { render } from "./SubscriptionMagicLinkModal.vue?vue&type=template&id=b1a9b8de"
import script from "./SubscriptionMagicLinkModal.vue?vue&type=script&lang=js"
export * from "./SubscriptionMagicLinkModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__